import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SummaryFlowViewComponent } from '../../summary-flow-view/summary-flow-view.component';
import { DefaultDisplayComponent } from "../default-display/default-display.component";

@Component({
    selector: 'textbox-display',
    templateUrl: './textbox-display.component.html',
    styleUrls: ['./textbox-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TextboxDisplayComponent extends DefaultDisplayComponent implements OnInit {
    get displayValue(): string {
        let data = "";
        if (this.question) {
            data = super.getQuestionValue();
        }
        return data;
    }
    constructor(
        
    ) { super(); }

    ngOnInit() {
       
    }
}
